import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import {validateFields, validateField} from './../../../utilities/validation/validator';
import {validationRules} from '../../../utilities/validation/validationVariables';
import {showAppLoader, hideAppLoader} from '../../Shared/Loader/LoaderSlice';
import lodash from 'lodash';
import Asmahta from '../DisconnectServicesBlock/DisconnectPage/DisconnectCommonParts/summaryNumberProvider';
import ProviderManager from '../../../provider/providerManager';

export const getCustomerServicesAvailableToDiscconect = createAsyncThunk('disconnectClientService/Disconnect', async (thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('disconnect', []);
    return result;
  } catch (error) {
    return {Body: {customerProducts: []}};
  }
});

export const disconnectProduct = createAsyncThunk('disconnectClientServiceSlice/disconnectProduct', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    const result = await ProviderManager.getProviderData('disconnectFinal', [
      data.ProductId,
      data.Round,
      data.Lfdat,
      data.WaitTo,
      data.WaitFrom,
      data.PickLocation,
      data.DisconnectReasons,
      data.DisconnectReference,
      data.DisconnectDate,
      data.HasDelivery,
      data.ShippingCost,
      data.Street,
      data.City,
      data.HouseNum,
      data.AptNum,
      data.PhoneNumber,
      data.Email,
      data.NotesForDelivery,
    ]);
    thunkAPI.dispatch(hideAppLoader());
    return result;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    return {Body: {productDisconnected: false}};
  }
});

export const getEquipmentForProduct = createAsyncThunk('disconnectClientServiceSlice/getEquipmentForProduct', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('equipmentForProduct', [data]);
    return result;
  } catch (error) {
    return {
      Body: {
        error: true,
      },
    };
  }
});

export const checkCanDisconnectService = createAsyncThunk('disconnectClientService/checkCanDisconnectService', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('disconnectAllowedForProduct', [data.productId]);
    if (result.Body.disconnectAllowed === true) {
      thunkAPI.dispatch(hideAppLoader());
      thunkAPI.dispatch(goToPage({page: 'CHOOSE_DISCONNECT_REASON', params: {hideHeader: false, serviceToDisconnect: data}}));
      return result;
    } else {
      thunkAPI.dispatch(hideAppLoader());
      thunkAPI.dispatch(goToPage({page: 'GET_BACK_TO_YOU_BY_NUMBER', params: {hideHeader: false, serviceToDisconnect: data}}));
      return result;
    }
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    thunkAPI.dispatch(goToPage({page: 'GET_BACK_TO_YOU_BY_NUMBER', params: {hideHeader: false, serviceToDisconnect: data}}));
    return {
      Body: {
        disconnectAllowed: false,
        hasDiscountedPackage: false,
        hasTechnician: false,
      },
    };
  }
});

export const setDelivery = createAsyncThunk('disconnectClientService/setDelivery', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('deliveryTimeSlots', [data.id, data.city, data.street, data.house]);
    return result;
  } catch (error) {
    return {error: true};
  }
});

export const checkCanUpgradeCellularProgram = createAsyncThunk(
  'disconnectClientServiceSlice/checkCanUpgradeCellularProgram',
  async (data, thunkAPI) => {
    thunkAPI.dispatch(showAppLoader());
    try {
      const result = await ProviderManager.getProviderData('getUpdateCellularPackage', [data.productId, data.upgradeCellularCode]);
      thunkAPI.dispatch(hideAppLoader());
      return result;
    } catch (error) {
      thunkAPI.dispatch(hideAppLoader());
      return {Body: false};
    }
  },
);

export const doCallBack = createAsyncThunk('disconnectClientService/doCallBack', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    const result = await ProviderManager.getProviderData('doCallBackToAuthorized', [data.id, data.mobile, data.code]);
    thunkAPI.dispatch(hideAppLoader());
    return {isSuccess: result.Body.isSuccess, errorCode: 0};
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    if (error.errorCode == '3' || error.errorCode === 3) {
      return {isSuccess: true, callBackAlreadyExist: true};
    }
    return {isSuccess: false, errorCode: error.errorCode};
  }
});

const initialState = {
  finalDisconnectResponse: '',
  deliverySet: '',
  disconnectTypeOfService: '',
  mobileToGetBackTo: '',
  userServices: [],
  equipmentForProductData: {},
  stepInProcess: 'MAIN_PAGE',
  serviceToDisconnect: {
    ServiceType: '',
    Email: '',
    ClientId: '',
    Address: '',
    BusinessTypeCanBeDisconnected: null,
    HasDiscountedPackage: null,
    HasTechnician: null,
    HasBanlvlPpUnlimited: null,
  },
  stepParams: {},
  summarizeUserDisconnectDetails: {
    returnToNumberForm: {
      cellular: '',
      valid: '',
      errors: {},
      rules: {
        cellular: validationRules.phone,
      },
    },
    disconnectReasons: [],
    deliveryCodes: {},
    deliveryNotes: '',
    equipmentReturnMethod: '',
    timeDisconnectOccurred: '',
    timeDisconnectScheduled: '',
    emailForm: {
      email: '',
      valid: '',
      errors: {},
      rules: {
        email: validationRules.email,
      },
    },
  },
  canUpgradeCellular: null,
  deliverySlotsResponse: [],
  deliverySlotsResponseFulfilled: false,
  loaderError: null,
  callBackAlreadyExist: null,
  CallbackIsSuccess: null,
  CallbackErrorCode: '',
  BillCycle: null,
  getEquipmentFatalError: null,
  writtenProofNumber: Asmahta(),
  changedDateOfDisconnect: false,
  isLoading: true,
};

const disconnectClientServiceSlice = createSlice({
  name: 'disconnectClientService',
  initialState: initialState,
  reducers: {
    resetState: (state) => initialState,
    setIsLoading: (state, action) => {
      return {
        ...state,
        isLoading: action.payload,
      };
    },
    setDefaultCellular: (state, action) => {
      return {
        ...state,
        summarizeUserDisconnectDetails: {
          ...state.summarizeUserDisconnectDetails,
          returnToNumberForm: {
            ...state.summarizeUserDisconnectDetails.returnToNumberForm,
            cellular: action.payload,
          },
        },
      };
    },
    addDisconnectReason: (state, action) => {
      return {
        ...state,
        summarizeUserDisconnectDetails: {
          ...state.summarizeUserDisconnectDetails,
          disconnectReasons: [...state.summarizeUserDisconnectDetails.disconnectReasons, action.payload],
        },
      };
    },
    removeDisconnectReason: (state, action) => {
      return {
        ...state,
        summarizeUserDisconnectDetails: {
          ...state.summarizeUserDisconnectDetails,
          disconnectReasons: state.summarizeUserDisconnectDetails.disconnectReasons.filter((reason) => reason !== action.payload),
        },
      };
    },
    setMobileToGetBackTo: (state, action) => {
      return {
        ...state,
        MobileToGetBackTo: action.payload,
      };
    },
    setHasDateChangedToDisconnect: (state, action) => {
      return {
        ...state,
        changedDateOfDisconnect: action.payload,
      };
    },
    setScheduleDateToDisconnect: (state, action) => {
      return {
        ...state,
        summarizeUserDisconnectDetails: {
          ...state.summarizeUserDisconnectDetails,
          timeDisconnectScheduled: action.payload,
        },
      };
    },
    setEquipmentReturnMethod: (state, action) => {
      return {
        ...state,
        summarizeUserDisconnectDetails: {
          ...state.summarizeUserDisconnectDetails,
          equipmentReturnMethod: action.payload,
        },
      };
    },
    setDeliveryCodes: (state, action) => {
      return {
        ...state,
        summarizeUserDisconnectDetails: {
          ...state.summarizeUserDisconnectDetails,
          deliveryCodes: action.payload,
        },
      };
    },
    setTimeDisconnectOccurred: (state, action) => {
      const today = new Date();
      const date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
      return {
        ...state,
        summarizeUserDisconnectDetails: {
          ...state.summarizeUserDisconnectDetails,
          timeDisconnectOccurred: date,
        },
      };
    },
    goToPage: (state, action) => {
      state.stepInProcess = action.payload.page;
      if (action.payload.params) state.stepParams = action.payload.params;
    },
    setDisconnectTypeOfService: (state, action) => {
      state.disconnectTypeOfService = action.payload;
    },
    setServiceToDisconnect: (state, action) => {
      state.serviceToDisconnect = action.payload;
    },
    setNotesToPickUp: (state, action) => {
      return {
        ...state,
        summarizeUserDisconnectDetails: {
          ...state.summarizeUserDisconnectDetails,
          deliveryNotes: action.payload,
        },
      };
    },
    validateMobileHandler: {
      reducer(state, action) {
        state.summarizeUserDisconnectDetails.returnToNumberForm = action.payload;
      },
      prepare(payload) {
        const validate = validateFields(lodash.cloneDeep(payload));
        return {payload: validate};
      },
    },
    changeMobileHandler: {
      reducer(state, action) {
        state.summarizeUserDisconnectDetails.returnToNumberForm = action.payload;
      },
      prepare(payload) {
        const name = payload.target.name;
        const value = payload.target.value;
        const form = lodash.cloneDeep(payload.form);
        const validate = validateField(form, name, value);

        if (validate.cellular.length > 10) {
          validate.cellular = validate.cellular.slice(0, 10);
          validate.errors.cellular = '';
        }

        return {payload: validate};
      },
    },
    validateMailHandler: {
      reducer(state, action) {
        state.summarizeUserDisconnectDetails.emailForm = action.payload;
      },
      prepare(payload) {
        const validate = validateFields(lodash.cloneDeep(payload));
        return {payload: validate};
      },
    },
    changeMailHandler: {
      reducer(state, action) {
        state.summarizeUserDisconnectDetails.emailForm = action.payload;
      },
      prepare(payload) {
        const name = payload.target.name;
        const value = payload.target.value;
        const form = lodash.cloneDeep(payload.form);
        const validate = validateField(form, name, value);
        return {payload: validate};
      },
    },
  },
  extraReducers: {
    [getCustomerServicesAvailableToDiscconect.fulfilled]: (state, action) => {
      return {...state, userServices: [...action.payload.Body.customerProducts]};
    },
    [getCustomerServicesAvailableToDiscconect.rejected]: (state, action) => {
      return {...state, loaderError: true};
    },
    [getEquipmentForProduct.fulfilled]: (state, action) => {
      if (action.payload.Body.error === true) {
        return {
          ...state,
          getEquipmentFatalError: action.payload.Body.error,
        };
      }
      return {
        ...state,
        equipmentForProductData: action.payload.Body,
      };
    },
    [checkCanDisconnectService.fulfilled]: (state, action) => {
      return {
        ...state,
        serviceToDisconnect: {
          ...state.serviceToDisconnect,
          BusinessTypeCanBeDisconnected: action.payload.Body.disconnectAllowed,
          HasDiscountedPackage: action.payload.Body.hasDiscountedPackage,
          HasTechnician: action.payload.Body.hasTechnician,
          HasBanlvlPpUnlimited: action.payload.Body.hasBanlvlPpUnlimited,
        },
      };
    },
    [doCallBack.fulfilled]: (state, action) => {
      state.CallbackIsSuccess = action.payload.isSuccess;
      state.CallbackErrorCode = action.payload.errorCode;
      state.callBackAlreadyExist = action.payload.callBackAlreadyExist;
    },
    [checkCanUpgradeCellularProgram.fulfilled]: (state, action) => {
      state.canUpgradeCellular = action.payload.Body;
    },
    [setDelivery.fulfilled]: (state, action) => {
      if ((Array.isArray(action.payload) && action.payload.length === 0) || action.payload.Body == null) {
        state.deliverySlotsResponseFulfilled = true;
        return;
      } else {
        state.deliverySlotsResponse = [...action.payload.Body.deliverySlots];
        state.deliverySlotsResponseFulfilled = true;
      }
    },
    [disconnectProduct.fulfilled]: (state, action) => {
      state.finalDisconnectResponse = action.payload.Body.productDisconnected;
      state.deliverySet = action.payload.Body.deliverySet;
      state.loaderError = false;
    },
  },
});

export const {
  stepParams,
  setIsLoading,
  setHasDateChangedToDisconnect,
  setDefaultCellular,
  resetState,
  setDeliveryCodes,
  setMobileToGetBackTo,
  setDisconnectServiceCode,
  validateMailHandler,
  changeMailHandler,
  changeMobileHandler,
  validateMobileHandler,
  setMobileToPickUp,
  setNotesToPickUp,
  setEquipmentReturnMethod,
  setTimeDisconnectOccurred,
  setScheduleDateToDisconnect,
  setServiceToDisconnect,
  setDisconnectTypeOfService,
  addDisconnectReason,
  removeDisconnectReason,
  goToPage,
} = disconnectClientServiceSlice.actions;

export default disconnectClientServiceSlice.reducer;
